module.exports = __webpack_public_path__ + "img/certificate.be8afa7e.svg";